import React from 'react'
import { useIntl } from 'react-intl'

import { type PromotionPlacement } from '@onr/schema'

import { formatPromotionFee } from '@/components/utils/formatPromotionFee'
import { cn } from '@/lib/utils'

export interface PromotionOptionSummaryProps extends React.HTMLAttributes<HTMLDivElement> {
  readonly placement: PromotionPlacement
  readonly fee?: number
}

export const PromotionOptionSummary = React.forwardRef<HTMLDivElement, PromotionOptionSummaryProps>(
  ({ placement, fee, className, ...props }, ref) => {
    const intl = useIntl()
    return (
      <div
        ref={ref}
        className={cn(
          'flex items-center justify-between gap-4 rounded-[4px] border border-gray-300 px-4 py-3',
          className
        )}
        {...props}>
        <div className="flex flex-col gap-1">
          <p className="text-base font-semibold text-gray-900">
            {intl.formatMessage({ id: `promotions.shop.options.${placement}.title` })}
          </p>
          <p className="text-sm text-gray-500">
            {intl.formatMessage({ id: `promotions.shop.options.${placement}.audience` })}
          </p>
        </div>
        <p className="text-lg whitespace-nowrap text-gray-900">
          {formatPromotionFee(intl, fee)}{' '}
          <span className="text-sm text-gray-500">
            {intl.formatMessage({ id: 'promotions.shop.dialog.perCampaign' })}
          </span>
        </p>
      </div>
    )
  }
)
